// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"b1d420b1","188":"092c5f41","251":"17d48f9e","787":"97e2e26b"}[chunkId] + ".chunk.js";
};